/**
 * A helper to round a number / metric to two decimal places
 * and add thousands comma separators
 */
export const formatNumber = (value: number | string): string =>
  Number(value).toLocaleString('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
